// Детерминированный ГСЧ (mulberry32) — состояние хранится в G.rng, чтобы партию можно было
// сериализовать/восстановить и воспроизвести (в том числе на сервере).
import type { Rng } from '../types.ts';

export function makeRng(seed: number): Rng {
  return { s: seed >>> 0 };
}

export function rand(rng: Rng): number {
  rng.s = (rng.s + 0x6d2b79f5) >>> 0;
  let t = rng.s;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function randInt(rng: Rng, n: number): number {
  return Math.floor(rand(rng) * n);
}

/** Перемешивает массив на месте и возвращает его же */
export function shuffle<T>(rng: Rng, arr: T[]): T[] {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = randInt(rng, i + 1);
    const a = arr[i] as T;
    arr[i] = arr[j] as T;
    arr[j] = a;
  }
  return arr;
}

export function pick<T>(rng: Rng, arr: readonly T[]): T | undefined {
  return arr[randInt(rng, arr.length)];
}
